


















































































import { ref, defineComponent, watch, computed } from '@vue/composition-api'
import { getMedicalMergePageInfo, grantQuery } from 'api/index'
import type { NewInsuranceInfoRes, InsuranceInfoParams, InsuranceInfoRes } from 'api/api-type'
import { params, omega } from '@didi/driver-biz-sdk'
import { showLoading, hideLoading } from 'common/ts/toast'
import Banner from '@/components/banner.vue'
import Advantage from '@/components/advantage.vue'
import Plan from '@/components/plan.vue'
import Rule from '@/components/rule.vue'
import Quest from '@/components/quest.vue'
import NumScroll from '@/components/num-scroll.vue'
import Footnote from '@/components/footnote.vue'
import FullScreenTips from '@/components/full-screen-tips.vue'
import BottomButton from '@/components/bottom-button/index.vue'
import PageTab from '@/components/page-tab.vue'
import SelfAdvantage from '@/components/self-advantage.vue'
import HotInsurance from '@/components/hot-insurance.vue'
import InsurancePanel from '@/components/insurance-panel.vue'
import FooterSystemInfo from '@/components/footer-system-info.vue'
import { useAdaptiveBottomHeight } from '@/components/bottom-button/index'
import { initShare } from 'common/biz/share'
import { addCornerButtonShare, addCornerButtonMore } from 'common/biz/corner-button'
import { regisitPageshowFn } from 'common/ts/wk-webview-handler'
import { backButtonCloseAll } from 'common/biz/back-button'
import { showReauthorizeModal } from 'common/biz/reauthorize-modal'
import { isInApp, PLATFORM, INSURANCE_ID, PAGE_TYPE_MAP, ALL_PAGE, DRIVER_GRADE, ZHUANCHE_LEVEL_MAP, KUAICHE_LEVEl_MAP } from 'common/biz/constants'
import { getInsuranceStatus } from './index'
import FloatBall from '@didi/driver-biz-ui/src/components/float-ball//float-ball.vue'
import { usePageInfo } from '@/store/index'
import { setTitle } from '@/common/ts/set-title'

export default defineComponent({
  setup() {
    const showPopup = ref(-1)
    const authProductLine = ref(0)
    const _grantQuery = () => {
      grantQuery({
        item_id: 1100
      }).then(res => {
        if (res.popup === 1) {
          showPopup.value = 1
          authProductLine.value = res.product_line
          showReauthorizeModal(res.product_line, true)
        } else {
          showPopup.value = res.popup
        }
      })
    }

    const activityStatus = ref(-1 as InsuranceInfoRes['ext']['activity_status'])
    watch([activityStatus, showPopup], (newV) => {
      const _cardData = cardData.value
      if (newV[0] > -1 && newV[1] > -1) {
        if (newV[0] === 1 || info.value.self_pay_tab) {
          addCornerButtonMore({
            ruleLink: info.value.detailed_rules_url,
            qaLink: info.value.common_problem_url,
            status: insuranceStatus.value,
            companyId: companyId.value, // 补贴的
            authProductLine: authProductLine.value,
            allCompanyIds: allCompanyIds.value, // 全部的
            contentType: (() => {
              if (_cardData.if_subsidy === true) {
                return _cardData.effective_num + _cardData.wait_effective_num > 1 ? 3 : 1
              } else if (_cardData.if_subsidy === false) {
                return 2
              }
              return 1
            })()
          })
        } else if (newV[0] === 0) addCornerButtonShare()
      }
    })

    backButtonCloseAll()
    regisitPageshowFn()

    const advantage = ref({} as InsuranceInfoRes['advantage'])
    const quest = ref({} as InsuranceInfoRes['quest'])
    const companyId = ref(0)
    const areaId = ref(Number(params.urlParams.area_id as string))
    const errmsg = ref('')
    const insuranceStatus = ref(-1)
    const insuranceInfo = ref({} as InsuranceInfoRes['insurance_data'])
    const apiLoaded = ref(false)
    const policyId = ref(0)
    const hotInsurance = ref([] as NewInsuranceInfoRes['product_data'])
    const selectedTab = ref(0)
    const allCompanyIds = ref<number[]>([])
    const cardData = ref({} as NewInsuranceInfoRes['card_data'])
    const info = ref({} as NewInsuranceInfoRes)
    const isDriverDay = computed(() => {
      return info.value.ext?.page_type === PAGE_TYPE_MAP.driverDay
    })
    watch(() => isDriverDay.value, (newV) => {
      newV && setTitle('滴滴司机节限时福利')
    }, { immediate: true })
    const bannerImg = computed(() => {
      const defaultImg = isDriverDay.value ? 'https://dpubstatic.udache.com/static/dpubimg/LklhYsc5Zk09a4p00xzuv_banner.png' : 'https://dpubstatic.udache.com/static/dpubimg/2vp_xgr0sLQv24CAisj2q.png'
      if (selectedTab.value === 1) {
        if (info.value.subsidy_tab) return defaultImg
        else return 'https://dpubstatic.udache.com/static/dpubimg/aOFGCD1TJ7MW9qWhkbuOQ.png'
      }

      return defaultImg
    })

    const pageInit = () => {
      showLoading()
      const ajaxParams: InsuranceInfoParams = {
        insurance_id: INSURANCE_ID,
        platform: PLATFORM
      }
      if (areaId.value && !isInApp) {
        ajaxParams.area_id = areaId.value
      }
      getMedicalMergePageInfo(ajaxParams).then((res) => {
        const store = usePageInfo()
        store.setDetail(res)
        hideLoading()
        if (res.insurance_data.access_threshold) {
          const gradeId = res.driver_data.grade_id
          if (res.driver_data.driver_grade === DRIVER_GRADE.zhuanche) {
            if (![
              ZHUANCHE_LEVEL_MAP.authentication,
              ZHUANCHE_LEVEL_MAP.senior,
              ZHUANCHE_LEVEL_MAP.outstanding,
              ZHUANCHE_LEVEL_MAP.specialStar
            ].includes(gradeId)) {
              res.driver_data.grade_id = ZHUANCHE_LEVEL_MAP.authentication
            }
          } else {
            if (![
              KUAICHE_LEVEl_MAP.one,
              KUAICHE_LEVEl_MAP.two,
              KUAICHE_LEVEl_MAP.three,
              KUAICHE_LEVEl_MAP.four,
              KUAICHE_LEVEl_MAP.five,
              KUAICHE_LEVEl_MAP.six
            ].includes(gradeId)) {
              res.driver_data.grade_id = KUAICHE_LEVEl_MAP.one
            }
          }
        }
        info.value = res
        if ('card_data' in res && res.card_data) {
          cardData.value = res.card_data
        }
        insuranceInfo.value = res.insurance_data
        advantage.value = res.advantage
        quest.value = res.quest
        companyId.value = Number(params.urlParams.company_id as string) || res.insurance_data?.company_id
        allCompanyIds.value.push(companyId.value)
        areaId.value = areaId.value || res.driver_data?.area_id
        insuranceStatus.value = getInsuranceStatus(res.insurance_data)
        activityStatus.value = res.ext.activity_status
        if ('product_data' in res && res.self_pay_tab) {
          hotInsurance.value = res.product_data
          res.companies && res.companies.forEach(item => {
            allCompanyIds.value.push(item)
          })
          if (params.urlParams.direct && info.value.self_pay_tab && hotInsurance.value) {
            selectedTab.value = 1
          } else {
            selectedTab.value = res.subsidy_tab ? Math.max(res.default_tab - 1, 0) : 1
          }
        }
        allCompanyIds.value = [...new Set(allCompanyIds.value)]
        if (res.insurance_data && res.insurance_data.policy_id) {
          policyId.value = res.insurance_data.policy_id
        }
        omega.setCommonParams({
          attrs: {
            driver_id: res.driver_data?.uid,
            page_type: (() => {
              if (res.ext.activity_status === 1) return 2 // 开城
              if ('card_data' in res && res.card_data) {
                return cardData.value.all_quilt_flag === 0 ? 3 : 4
              }
              return 1 // 预热、默认
            })()
          }
        })

        initShare({ companyId: companyId.value, areaId: areaId.value })
        omega.trackEvent(
          isInApp
            ? activityStatus.value === 1 ? 'am_c_insure_medinsurland_sw' : 'am_c_insure_medinsurebjoin_sw'
            : 'am_c_insure_medinsurebjoins_sw'
        )
      }).catch(err => {
        hideLoading()
        errmsg.value = err.errmsg
        omega.trackEvent('wyc_driver_biz_medical_page_error_bt', {
          stack: err.stack,
          message: err.message,
          errno: err.errno,
          trace_id: err.trace_id
        })
      }).finally(() => {
        apiLoaded.value = true
      })
    }
    _grantQuery()
    pageInit()

    function linkToAllPage() {
      omega.trackEvent('am_c_insure_medical_moreguarantee_ck', {
        pageproperty: activityStatus.value === 0
          ? 1
          : insuranceStatus.value === 0 ? 2 : 3
      })
      const ticket = params.commonParams.ticket
      const postText = process.env.API_ENV === 'development' ? `&ticket=${ticket}` : ''
      window.location.href = ALL_PAGE + postText
    }

    const [footerStyle, btn] = useAdaptiveBottomHeight()

    const showQuest = computed(() => {
      if (!quest.value || !quest.value.quest_content) return false

      if (activityStatus.value === 1 && insuranceStatus.value === 0) return true

      return false
    })
    return {
      info,
      showQuest,
      areaId,
      allCompanyIds,
      hotInsurance,
      selectedTab,
      policyId,
      footerStyle,
      btn,
      apiLoaded,
      advantage,
      quest,
      isDriverDay,
      companyId,
      activityStatus,
      insuranceStatus,
      errmsg,
      insuranceInfo,
      isInApp,
      cardData,
      bannerImg,
      linkToAllPage
    }
  },
  components: {
    Banner,
    PageTab,
    SelfAdvantage,
    HotInsurance,
    Advantage,
    InsurancePanel,
    Plan,
    Rule,
    Quest,
    Footnote,
    BottomButton,
    FullScreenTips,
    FloatBall,
    NumScroll,
    FooterSystemInfo
  }
})
